import Lottie from "lottie-react";
import loader from '../../assets/lottie/7774-loading.json';
import logo from '../../assets/images/logoimg.png';

const PreLoader = () => {
    return(
        <div className="relative h-screen w-full flex justify-center items-center bg-white">
            <div className="w-48 md:w-64">
                <Lottie animationData={loader} loop={true} />
            </div>
            
            <img 
                className="absolute bottom-12 md:bottom-20 left-1/2 -translate-x-1/2 w-[140px] md:w-[200px] z-[9999]" 
                src={logo} 
                alt="logo ruumies" 
            />
        </div>
    )
}

export default PreLoader;